import { FC } from 'react';

import { AboutCompanyContainer } from '../AboutCompany';
import { ContactsContainer } from '../ContactsContainer';
import { ContentTabsContainer } from '../ContentTabsContainer';
import { OfferGroupsContainer } from '../Offers/OfferGroups';
import { Layout } from 'shared/components/Layout';

export const PageContainer: FC = () => {
  return (
    <Layout
      main={
        <>
          <AboutCompanyContainer />
          <ContentTabsContainer />
        </>
      }
      aside={<ContactsContainer />}
      bottom={<OfferGroupsContainer />}
    />
  );
};
